import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import {
  PHONE_BAR_WIDTH,
  STAGE_SLOT_MIN_HEIGHT,
  STAGE_SLOT_MIN_WIDTH,
  SUBTITLE_BAR_HEIGHT,
} from '@/experiences/sales-portal/domain/prospects/screens/prospect-detail/constants';
import { View } from 'react-native';

const NAME_BAR_HEIGHT = 24;
const NAME_BAR_WIDTH = 150;
const ADDRESS_BAR_WIDTH = 213;

export const ProspectDetailHeaderSkeleton: React.FC = () => {
  const [styles, theme] = useStyles();

  const borderRadius = theme.sk.radii.radiusRound;

  return (
    <View style={styles.container}>
      <View style={styles.nameRow}>
        <AnimatedSkeletonLoader
          borderRadius={borderRadius}
          height={NAME_BAR_HEIGHT}
          width={NAME_BAR_WIDTH}
        />
        <AnimatedSkeletonLoader
          borderRadius={borderRadius}
          height={STAGE_SLOT_MIN_HEIGHT}
          width={STAGE_SLOT_MIN_WIDTH}
        />
      </View>
      <AnimatedSkeletonLoader
        borderRadius={borderRadius}
        height={SUBTITLE_BAR_HEIGHT}
        width={ADDRESS_BAR_WIDTH}
      />
      <AnimatedSkeletonLoader
        borderRadius={borderRadius}
        height={SUBTITLE_BAR_HEIGHT}
        width={PHONE_BAR_WIDTH}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    gap: theme.sk.spacing.spaceSmall,
  },
  nameRow: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));
